import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { ROUTES } from './app.routes';

import { AppConfiguration, ConfigLoader, ConfigStaticLoader, DataAccessModule } from '@bhd/data-access';
import { StorageWebModule } from '@bhd/storage-web';
import { DeviceWebModule } from '@bhd/device-web';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '@env/environment';
import { FeatureFlagsModule } from '@bhd/feature-flags';

export function configLoader() {
  const { production, apiUrl, appVersion, channel, userImgPath, enrollUrl } = environment;
  const configApp: AppConfiguration = {
    environment: {
      production,
      apiUrl,
      appVersion,
      channel,
      platform: 'WEB',
      userImgPath,
      enrollUrl
    }
  };

  return new ConfigStaticLoader(configApp);
}

const DATA_ACCESS_SETUP = {
  loader: {
    provide: ConfigLoader,
    useFactory: configLoader,
    deps: [HttpClient]
  }
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(ROUTES, {
      bindToComponentInputs: true
    }),
    StorageWebModule,
    DeviceWebModule,
    DataAccessModule.forRoot(DATA_ACCESS_SETUP),
    HttpClientModule,
    BrowserAnimationsModule,
    DeviceWebModule.forRoot(),
    FeatureFlagsModule
  ],
  exports: [RouterModule],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
